import { member as memberApi } from '../../../api';
import { useApi, useInternationalization } from '../../../hooks';
import { ChangeRequestState, MemberChangeRequestFilter } from '../../../types';
import { MIN_PAGINATION_FILTER } from '../../../constants';
import { SyncProblemRounded } from '@mui/icons-material';
import { routes } from '../../../routes';
import { CounterWidget } from './CounterWidget';
import { WidgetProps } from './Widget';

const filter: MemberChangeRequestFilter = {
  state: ChangeRequestState.Submitted,
  ...MIN_PAGINATION_FILTER,
};

export const MemberChangeRequests = (props: WidgetProps) => {
  const { t } = useInternationalization();
  const { data, isLoading } = useApi(memberApi.getAllChangeRequests, null, filter);

  return (
    <CounterWidget
      {...props}
      isLoading={isLoading}
      count={data?.totalCount}
      title={t('dashboard:memberChangeRequests:title')}
      icon={SyncProblemRounded}
      link={routes.Admin.ChangeRequests.Member.path}
    />
  );
};
